<div class="row">
  <div class="col-lg-12">
    <div class="card card-primary">
      <div class="card-header text-uppercase"> {{title}} </div>
      <div class="card-body">
        <ul class="list-unstyled">
          <li class="media">
            <h5 class="mr-3 text-danger"> NOTE:</h5>
            <div class="media-body">
              <h6 class="mt-0 mb-1">You logged in with a SerialNo. <mark>{{applicantData.StudentNumber}}</mark> and Online ID No. <mark>{{applicantData.FormPinCode}}</mark>.</h6>
              For a complete and successful online application, please make sure that you have completed all the steps
              below:.
            </div>
          </li>
          <li class="media my-4">
            <h6 class="mr-3 text-primary"> STEP 1</h6>
            <div class="media-body">
              <h6 class="mt-0 mb-1">Upload your recent passport size picture</h6>
              Note: Your picture must be of <mark>JPEG (Joint Photographic Experts Group) or (Graphics Interchange Format)</mark>
              file format with a file size not more than <mark>65KB and a White Background</mark>.
            </div>
          </li>
          <li class="media">
            <h5 class="mr-3 text-primary"> STEP 2</h5>
            <div class="media-body">
              <h6 class="mt-0 mb-1">Provide your Personal and Parental / Guardian Information.</h6>
              <br/>
              <!-- Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus
              odio, vestibulum in vulputate at, tempus viverra turpis.  -->
            </div>
          </li>
          <li class="media">
            <h5 class="mr-3 text-primary"> STEP 3</h5>
            <div class="media-body">
              <h6 class="mt-0 mb-1"> Provide High School Records</h6>
              <br/>
              <!-- Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus
              odio, vestibulum in vulputate at, tempus viverra turpis.  -->
            </div>
          </li>
          <li class="media">
            <h5 class="mr-3 text-primary"> STEP 4</h5>
            <div class="media-body">
              <h6 class="mt-0 mb-1"> Provide your programme of choice.</h6>
              <br/>
              <!-- Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin.  -->
            </div>
          </li>
          <li class="media">
            <h5 class="mr-3 text-primary"> STEP 5</h5>
            <div class="media-body">
              <h6 class="mt-0 mb-1"> Data Verification and Printing of Application Records.</h6>
              <br/>
              <!-- Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus
              odio, vestibulum in vulputate at, tempus viverra turpis.  -->
            </div>
          </li>
        </ul>
      </div>
<div class="form-footer">
                <div class="form-group text-center">
                      <button type="button" (click)="goToNext()"
            class="btn btn-primary waves-effect waves-light m-1">Begin Or Edit Application Process
      </button>

                </div>


</div>

    </div>
  </div>
</div>